export const formatDate = (dateString) => {
    if(dateString){
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }else{
        return '';
    }
};

export const dateStringToISO = (dateString) => {
    if (!dateString) return null;

    let parts = dateString.split('-');
    if (parts.length !== 3) return null;

    let year = parts[0];
    let month = parts[1].padStart(2, '0');
    let day = parts[2].padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export const gradientGetter = (product)=> {
    if(product){
        if (product.startsWith(Products.ULTIMATE) || product.startsWith(Products.COMPLEMENTARY_ULTIMATE)) {
            return "account-village"
        } else if (product.startsWith(Products.SPORTS) || product.startsWith(Products.COMPLEMENTARY)) {
            return "account-valuepack"
        } else if (product.startsWith(Products.FAMILY)) {
            return "account-plus"
        }else if (product.startsWith(Products.VILLAGE)) {
            return "account-village"
        }else if (product.startsWith(Products.VALUEPACK)) {
            return "account-valuepack"
        }else if (product.startsWith(Products.FREE)) {
            return "account-free"
        }else if (product.startsWith(Products.ANT1PLUS)) {
            return "account-plus"
        }
    }
    return "account-free"
}

export const Products = Object.freeze({
    FREE: "Free",
    ULTIMATE: "ANT1+ Sports Ultimate_",
    SPORTS: "ANT1+ Sports_",
    FAMILY: "ANT1+ Family_",
    VILLAGE: "ANT1+ Village",
    VALUEPACK: "ANT1+ Value Pack",
    ANT1PLUS: "ANT1+",
    COMPLEMENTARY_ULTIMATE: "Diamond_ComplimentaryUltimate_1M",
    COMPLEMENTARY: "Platinum_Complimentary_1M",
})

export const SubscriptionStatus = Object.freeze({
    ActiveCancelled: "Active - Cancelled",
    ActiveInGrace: "Active - In Grace"
})

export const COMPLEMENTARY_PRODUCTS = Object.freeze([Products.COMPLEMENTARY, Products.COMPLEMENTARY_ULTIMATE])